
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.Container_b782275e88cce4fd{min-height:20px;cursor:pointer;margin:10px 0;display:flex;flex-flow:row;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.Container_b782275e88cce4fd.disabled_bffa410dd749dbb4{cursor:default;color:var(--disabledColor_7c97809fdebf9848)}.Circle_8ca41e76766122a3{position:relative;display:inline-block;width:40px;bottom:10px;height:40px;margin-right:8px;border-radius:50%;flex-shrink:0}.Dot_e886fe1402d00742:after,.Dot_e886fe1402d00742:before{content:"";position:absolute;left:0;top:0}.Dot_e886fe1402d00742:before{width:20px;height:20px;background:#fff;border:2px solid var(--borderColor_787178492c3b319e);border-radius:50%;transition:background .3s;box-sizing:border-box;margin:10px}.Dot_e886fe1402d00742:after{width:16px;height:16px;align-items:center;top:12px;left:1px;right:10px;border-radius:50%;border:3px solid transparent;margin:0 0 0 11px}.Dot_e886fe1402d00742.error_136ccb75edadc1d5:before{border:3px solid var(--errorColor_75086155d1d5750c)}.Input_3d74a561441a04b4{width:0;outline:0;opacity:0}.Input_3d74a561441a04b4:checked+.Circle_8ca41e76766122a3 .Dot_e886fe1402d00742:before{background:var(--color_7816dab1c5ccf9cd);border-color:var(--color_7816dab1c5ccf9cd)}.Input_3d74a561441a04b4:checked+.Circle_8ca41e76766122a3 .Dot_e886fe1402d00742:after{border-color:#fff}.Input_3d74a561441a04b4:checked:focus+.Circle_8ca41e76766122a3{background:var(--selectedFocusedColor_845077bec366e5df)}.Input_3d74a561441a04b4:disabled+.Circle_8ca41e76766122a3 .Dot_e886fe1402d00742:before{border-color:var(--disabledColor_7c97809fdebf9848)}.Input_3d74a561441a04b4:disabled:checked+.Circle_8ca41e76766122a3 .Dot_e886fe1402d00742:before{background:var(--disabledColor_7c97809fdebf9848)}.Input_3d74a561441a04b4:not(:checked):focus+.Circle_8ca41e76766122a3{background:var(--unselectedFocusedColor_e39b43675a3f3eaf)}.ErrorIcon_469d1a2b6815f5d6{color:#fff;margin:8px;width:20px;height:20px;pointer-events:none;flex-shrink:0;flex-grow:0}.Message_60573052b3f18cf0{display:none;height:0;margin:16px 0;position:relative;transition:all 1s ease-in-out}.Message_60573052b3f18cf0.error_136ccb75edadc1d5{display:flex;background-color:var(--errorColor_75086155d1d5750c);color:#fff;height:auto;padding:8px;border-radius:5px;transition:all 1s ease-in-out}.Message_60573052b3f18cf0:after{width:0;content:"";height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:10px solid var(--errorColor_75086155d1d5750c);bottom:-8px;left:5px;position:absolute}`;
styleInject(_css)

/** Container Props */
export type ContainerCCM = {
  /** Container Component Custom Properties */
  '$disabledColor': string;

  /** Container Modifier Flags */
  '$disabled'?: boolean;
};
/** Base Container component */
export const Container: ComponentCreator<ContainerCCM> = createComponentCreator({
  "name": "Container",
  "base": "Container_b782275e88cce4fd",
  "prop": {
    "$disabledColor": "--disabledColor_7c97809fdebf9848"
  },
  "mod": {
    "$disabled": "disabled_bffa410dd749dbb4"
  }
});


/** Circle Props */
export type CircleCCM = {
  /** Circle Component Custom Properties */
  '$selectedFocusedColor': string;
  '$unselectedFocusedColor': string;

  /** Circle Modifier Flags */
  // No modifiers classes found
};
/** Base Circle component */
export const Circle: ComponentCreator<CircleCCM> = createComponentCreator({
  "name": "Circle",
  "base": "Circle_8ca41e76766122a3",
  "prop": {
    "$selectedFocusedColor": "--selectedFocusedColor_845077bec366e5df",
    "$unselectedFocusedColor": "--unselectedFocusedColor_e39b43675a3f3eaf"
  },
  "mod": {}
});


/** Dot Props */
export type DotCCM = {
  /** Dot Component Custom Properties */
  '$borderColor': string;
  '$errorColor': string;
  '$color': string;
  '$disabledColor': string;

  /** Dot Modifier Flags */
  '$error'?: boolean;
};
/** Base Dot component */
export const Dot: ComponentCreator<DotCCM> = createComponentCreator({
  "name": "Dot",
  "base": "Dot_e886fe1402d00742",
  "prop": {
    "$borderColor": "--borderColor_787178492c3b319e",
    "$errorColor": "--errorColor_75086155d1d5750c",
    "$color": "--color_7816dab1c5ccf9cd",
    "$disabledColor": "--disabledColor_7c97809fdebf9848"
  },
  "mod": {
    "$error": "error_136ccb75edadc1d5"
  }
});


/** Input Props */
export type InputCCM = {
  /** Input Component Custom Properties */
  // No custom properties found

  /** Input Modifier Flags */
  // No modifiers classes found
};
/** Base Input component */
export const Input: ComponentCreator<InputCCM> = createComponentCreator({
  "name": "Input",
  "base": "Input_3d74a561441a04b4",
  "prop": {},
  "mod": {}
});


/** ErrorIcon Props */
export type ErrorIconCCM = {
  /** ErrorIcon Component Custom Properties */
  // No custom properties found

  /** ErrorIcon Modifier Flags */
  // No modifiers classes found
};
/** Base ErrorIcon component */
export const ErrorIcon: ComponentCreator<ErrorIconCCM> = createComponentCreator({
  "name": "ErrorIcon",
  "base": "ErrorIcon_469d1a2b6815f5d6",
  "prop": {},
  "mod": {}
});


/** Message Props */
export type MessageCCM = {
  /** Message Component Custom Properties */
  '$errorColor': string;

  /** Message Modifier Flags */
  '$error'?: boolean;
};
/** Base Message component */
export const Message: ComponentCreator<MessageCCM> = createComponentCreator({
  "name": "Message",
  "base": "Message_60573052b3f18cf0",
  "prop": {
    "$errorColor": "--errorColor_75086155d1d5750c"
  },
  "mod": {
    "$error": "error_136ccb75edadc1d5"
  }
});

